// extracted by mini-css-extract-plugin
export default {"bottom_affix":"index_bottom_affix_aXu-8","backToTop":"index_backToTop_8yye-"};